export default "__VITE_ASSET__DnWJ5zN1__"